module.exports = __webpack_public_path__ + "static/michael-close-min-069ba34f9e6bb361e4ebaa95884dda69.jpg";